/* v8 ignore start */
import {useEffect} from "react";

import {useAppDispatch} from "@/store";
import {setIsMobile} from "@/store/slices/viewSlice";

function ScreenInitializer() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.matchMedia("(max-width: 950px)").matches;
    const isMobile = isTouchDevice && isSmallScreen;

    dispatch(setIsMobile(isMobile));
  }, [dispatch]);

  return null;
}

export default ScreenInitializer;
/* v8 ignore stop */
